import { FC, useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import queryString from 'query-string'
import Flatpickr from "react-flatpickr";
import {Vietnamese} from "flatpickr/dist/l10n/vn.js"
import { shallowEqual, useSelector } from "react-redux";
import { PaginateModel } from "../../../models/PaginateModel";
import { AbilityModel, ModalModel, SearchModel } from "../../../models/AbilityModel";
import { RootState } from "../../../../setup";
import { UserModel } from "../../../modules/auth/models/UserModel";
import { formatPrice } from "../../../selectors";
import { PaginationLength } from "../../../../_metronic/partials/pagination/PaginationLength";
import * as DebtCRUD from '../DebtCRUD';
import { PaginationHeader } from "../../../../_metronic/partials/pagination/PaginationHeader";
import { Paginate } from "../../../../_metronic/partials/pagination/Paginate";
import { ABILITIES_TYPES, DEFAULT_PER_PAGE, RECIEPT_VOUCHER } from "../../../constants/common";
import { Toast, download } from "../../../modules/common/helper";
import { SupplierModel } from "../../../models/SupplierModel";
import SupplierDebtTable from "./SupplierDebtTable";
import PaymentVoucher from "../../abilities/agency/PaymentVoucherModal";
import SupplierDebtModal from "./SupplierDebtModal";
import {Sento, UserLoggedIn} from "../../../hooks/PermissionChecker";
import { HeaderModel } from "../../../models/CommonModel";
import ConfigModal from "./ConfigModal";
import useMasterData from "../../../hooks/useMaster";
import { update } from "../../abilities/AbilitiesCRUD";
import moment from "moment";
import DropDown from "../../../components/Control/DropDown";

const SupplierDebt: FC = () => {
    const intl = useIntl();
    const history = useHistory();
    const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
    const fp = useRef<any>(null);
    const parseParams = (params: SearchModel) => {
        if (params.page) {
            params.page = +params.page
        }
        if (params.per_page) {
            params.per_page = +params.per_page
        }
        return params
    }
    const searchHistory = history.location.search;
    const initParams: SearchModel = parseParams(queryString.parse(searchHistory))

    const [dataPaginate, setDataPaginate] = useState<PaginateModel<SupplierModel>>();
    const [hideCols, setHideCols] = useState<string[]>([]);
    const [invoiceFile, setInvoiceFile] = useState<File|null>(null)
    const [configModal, setConfigModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });
    const [paymentVoucherModal, setPaymentVoucherModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });

    const [debtDetailModal, setDebtDetailModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });
    const [totalDebt, setTotalDebt] = useState<number>(0);
    
    const initRange:any = [initParams?.start_date ?? moment(user?.store?.created_at).format('YYYY-MM-DD'), initParams?.end_date ?? moment().format('YYYY-MM-DD')]
    const initSearch = {
        page: 1,
        per_page: DEFAULT_PER_PAGE,
        store_id: UserLoggedIn().store_id,
        start_date: initRange[0],
        end_date: initRange[1]
    }
    const [search, setSearch] = useState<SearchModel>(initSearch)

    useEffect(() => {
		document.title = 'Sento - Công nợ nhà cung cấp';
	})

    useEffect(() => {
        const searchHistory = history.location.search;
        const initParams: SearchModel = parseParams(queryString.parse(searchHistory))
        getData({ ...search, ...initParams });
    }, []);

    const getData = async (params?: SearchModel) => {
        const { data: resData } = await DebtCRUD.getSupplierDebt({...params});
        const objQuery = { ...params }
        if (objQuery.page === 1) {
            delete objQuery.page
        }
        if (objQuery.per_page === DEFAULT_PER_PAGE) {
            delete objQuery.per_page
        }
        history.push({ search: `?${queryString.stringify(objQuery)}` })
        setDataPaginate(resData?.paginate_data);
        setTotalDebt(resData?.total_debt ?? 0)
        setSearch(params ?? {});
    }

    const handlePageChange = (data: any) => {
        getData({ ...search, page: data.selected + 1 })
    }

    const handlePageLengthChange = (e: any) => {
        getData({ ...search, page: 1, per_page: +e.target.value })
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        getData({ ...search, page: 1 })
    }

    const handleClearSearch = (e: any) => {
        e.preventDefault();
        setSearch(initSearch);
        if (fp.current?.flatpickr) {
            fp.current.flatpickr.clear();
        }
        getData(initSearch)
    }

    const handleSubmit = async (values: any, actions: any) => {
        const formData = new FormData();
        Object.keys(values).forEach((key) => {
            if (values[key] !== undefined && values[key] !== null) {
                formData.append(key, values[key]);
            }
        });
        formData.append('purpose', 'expenses');
        if (invoiceFile) {
            formData.append('file', invoiceFile);    
        }
        
        if (values?.id) {
            handleUpdateAbility(formData, values?.id)
            return
        }

        handleCreateAbility(formData)
    };

    const handleCreateAbility = async (formData: FormData) => {
        let result = DebtCRUD.store(formData);
        let message = 'Tạo phiếu chi thành công!'
        result.then(res => {
            Toast.fire({
                icon: 'success',
                title: message
            })
            setPaymentVoucherModal({ ...paymentVoucherModal, show: false })
            getData({ ...search, page: 1 })
        }).catch(error => {
            const response = error.response
            let message: string = '';
            if (response?.status === 422) {
                if (response?.data?.errors) {
                    const arrMess = [];
                    for (const [key, mess] of Object.entries(response?.data?.errors)) {
                        arrMess.push(mess);
                    }
                    message = arrMess.join("\n")
                }
            } else {
                message = 'Đã có lỗi xảy ra vui lòng liên hệ Admin'
            }
            Toast.fire({
                icon: 'error',
                title: message
            })
        });
    }

    const handleUpdateAbility = async (formData: FormData, id: number) => {
        let result = update(formData, id);
        let message = 'Cập nhật phiếu chi thành công!'
        result.then(res => {
            Toast.fire({
                icon: 'success',
                title: message
            })
            setPaymentVoucherModal({ ...paymentVoucherModal, show: false })
            getData({ ...search, page: 1 })
        }).catch(error => {
            const response = error.response
            let message: string = '';
            if (response?.status === 422) {
                if (response?.data?.errors) {
                    const arrMess = [];
                    for (const [key, mess] of Object.entries(response?.data?.errors)) {
                        arrMess.push(mess);
                    }
                    message = arrMess.join("\n")
                }
            } else {
                message = 'Đã có lỗi xảy ra vui lòng liên hệ Admin'
            }
            Toast.fire({
                icon: 'error',
                title: message
            })
        });
    }

    const handleViewDetail = (supplier: SupplierModel) => {
        setDebtDetailModal({ ...debtDetailModal, show: true, data: {...debtDetailModal?.data, supplier: supplier} })
    }

    const handlePaymentVoucher = async (supplier: SupplierModel) => {
        setPaymentVoucherModal({ ...paymentVoucherModal, show: true, data: {...paymentVoucherModal?.data, supplier: supplier, expense_group: 'debt'} })
    }
    
    const header: HeaderModel[] = [
        {
            label: intl.formatMessage({ id: 'SUPPLIER.NAME' }),
            style: { minWidth: "150px" },
            field: 'name',
            sortable: true
        },
        {
            label: 'Ngày thu cuối cùng',
            style: { minWidth: "100px" },
            field: 'ability_max_date',
            sortable: true
        },
        {
            label: 'Công nợ',
            style: { minWidth: "100px" },
            field: 'debt',
            sortable: true
        },
        {
            label: 'Ghi chú',
            style: { minWidth: "250px" },
            field: 'ability_last_note',
            sortable: false
        }
    ]

    const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
        const currentSearch = { ...search };
        const sortParams: SearchModel = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
        if (direction === 'none') {
            delete sortParams.sort_by;
            delete sortParams.sort_direction;
        }
        getData({ ...sortParams });
    }

    const handleChangeVisCols = (e: any) => {
        let hiddenCols = [...hideCols];
        if (!e.target?.checked) {
            setHideCols([...hiddenCols, e.target.name])
        } else {
            setHideCols(hiddenCols.filter((item) => item !== e.target.name))
        }
    }

    const onChangeHasDebt = (e: any) => {
        const checked = e.target.checked
        let newSearch = {
            ...initSearch,
            has_debt: checked ? 1 : 0
          }
          getData(newSearch);
    }

    const onChangeConsignSupplier = (e: any) => {
        const checked = e.target.checked
        let newSearch = {
            ...search,
            is_consign_supplier: checked ? 1 : 0
          }
          getData(newSearch);
    }

    const handleExportDebt = async (template: string) => {
        const { data } = await DebtCRUD.exportSupplierDebt({ ...search, template: template });
        download(data, 'supplier-debt');
    }
    return <>
        <div className="card">
            <div className="card-header p-3">
                <div className="col-md-12">
                    <form onSubmit={handleSearch}>
                        <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">{intl.formatMessage({ id: 'COMMON.KEYWORD' })}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    name="keyword"
                                    value={search.keyword || ''}
                                    onChange={(e) => setSearch({ ...search, keyword: e.target.value })}
                                    autoComplete='nope'
                                />
                            </div>
                            <div className='col-md-4 '>
                                <label className="form-label">{intl.formatMessage({ id: 'COMMON.TIME' })}</label>
                                <Flatpickr
                                    ref={fp}
                                    onChange={(date) => {
                                        let startDate = moment(date[0]).format('YYYY-MM-DD');
                                        let endDate = moment(date[1]).format('YYYY-MM-DD');
                                        setSearch({ ...search, start_date: startDate, end_date: endDate });
                                    }}
                                    options={{
                                        mode: "range",
                                        dateFormat: 'd-m-Y',
                                        locale: Vietnamese,
                                        enableTime: false,
                                        defaultDate: [moment(initRange[0]).format('DD-MM-YYYY'), moment(initRange[1]).format('DD-MM-YYYY')],
                                    }}
                                    className='form-control'
                                    placeholder=''
                                />
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className='d-flex'>
                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                    <input className="form-check-input" type="checkbox" value="" id="has_debt"
                                        name='has_debt'
                                        checked={search?.has_debt ? true : false}
                                        onChange={onChangeHasDebt}/>
                                    <label htmlFor="has_debt" className="form-check-label">Hiển thị công nợ</label>
                                </label>
                                <label className='form-check form-check-sm form-check-custom form-check-solid ms-2'>
                                    <input className='form-check-input'
                                        type='checkbox' name='is_consign_supplier'
                                        checked={search?.is_consign_supplier ? true : false}
                                        onChange={onChangeConsignSupplier}
                                    />
                                    <span className='form-check-label'>NCC Ký gửi</span>
                                </label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="btns-group d-flex align-items-center">
                                <button
                                    className="col-auto btn btn-primary  my-1 me-2"
                                    onClick={handleSearch}
                                >
                                    <i className="bi bi bi-search fs-4"></i> {intl.formatMessage({ id: 'COMMON.SEARCH' })}
                                </button>
                                <button
                                    className="col-auto btn btn-danger my-1 me-2"
                                    type="button"
                                    onClick={handleClearSearch}
                                >
                                    <i className="bi bi-eraser-fill fs-1"></i> Re-search
                                </button>
                                <DropDown
                                    classString="my-1 col-auto"
                                    items={[
                                        {
                                            value: "accounting",
                                            label: "Mẫu kế toán",
                                            description: "Đầy đủ chi tiết số liệu",
                                            icon: "bi bi-file-earmark-excel-fill text-success",
                                        },
                                        {
                                            value: "default",
                                            label: "Mẫu khách hàng",
                                            description: "Đơn giản, dễ theo dõi",
                                            icon: "bi bi bi-file-earmark-check-fill text-primary",
                                        },
                                    ]}
                                    onChange={(val) => handleExportDebt(val)}
                                />
                            </div>
                            
                        </div>
                    </form>
                </div>
            </div>
            <div className="card-body p-3">
                <div className="row justify-content-between align-items-center mb-3">
                    <div className='col-12 col-md-6'>
                        <PaginationHeader from={dataPaginate?.meta?.from || 0} to={dataPaginate?.meta?.to || 0}
                            total={dataPaginate?.meta?.total || 0} />
                    </div>
                    <div className='col-12 col-md-6 text-start text-md-end'>
                        <h3>Tổng cộng: <span className="text-bold">{ formatPrice(totalDebt) } VNĐ</span></h3> 
                    </div>
                </div>
                <SupplierDebtTable
                    data={dataPaginate?.data || []}
                    handleViewDetail={handleViewDetail}
                    handlePaymentVoucher={handlePaymentVoucher}
                    openColConfig={() => setConfigModal({ ...configModal, show: true })}
                    header={header}
                    hideCols={hideCols}
                    handleSort={handleSort}
                />
                <PaymentVoucher
                    {...paymentVoucherModal}
                    onClose={() => { setPaymentVoucherModal({ ...paymentVoucherModal, show: false }) }}
                    onSubmit={handleSubmit}
                    setInvoiceFile={setInvoiceFile}
                />
                <SupplierDebtModal
                    {...debtDetailModal}
                    onClose={() => { setDebtDetailModal({ ...debtDetailModal, show: false }) }}
                    handleEditItem={(item: AbilityModel) => setPaymentVoucherModal({...paymentVoucherModal, mode: 'edit', data: item, show: true})}
                />
            </div>
            <div className="card-footer d-flex justify-content-between paginate-wrapper">
                <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE} onChange={handlePageLengthChange} />
                <Paginate
                    pageCount={dataPaginate?.meta?.last_page || 0}
                    onPageChange={handlePageChange}
                    forcePage={(search.page || 1) - 1}
                />
            </div>
            <ConfigModal
                {...configModal}
                header={header}
                hideCols={hideCols}
                handleChangeVisCols={handleChangeVisCols}
                onClose={() => { setConfigModal({ ...configModal, show: false }) }}
            />
        </div>
    </>
}
export default SupplierDebt;